import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpServiceService } from 'src/app/http-service.service';
import { UtilService } from 'src/app/util.service';
import { LoaderService } from 'src/app/loader.service';
import { AlertService } from 'src/app/alert.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-client-partners-list',
  templateUrl: './client-partners-list.component.html',
  styleUrls: ['./client-partners-list.component.scss']
})
export class ClientPartnersListComponent implements OnInit {

  ourteam: any = {};
  clientPartnersData:any = [];

  json: any = [];
  constructor(private router: Router,
    public httpService: HttpServiceService, public alertService: AlertService,
    public util: UtilService, public sanitizer: DomSanitizer,
    public loaderService: LoaderService) {

  }
  
  ngOnInit() {
    this.loadData();
  }

   loadData() {
    this.clientPartnersData = []
    this.loaderService.showLoader('Fetching Please wait ..').then(() => {
      try {
        this.httpService.getApi('Client/client_partners_list').subscribe(async (res: any) => {
          this.clientPartnersData = res.data ? res.data : [];
          this.loaderService.hideLoader();
        }, (err) => {

          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
        });
      } catch (e) {
        this.loaderService.hideLoader();
      }

    });
  }

  
  add() {
    this.router.navigate(['/client-partner-add'])
  }

  details(data) {
    localStorage.setItem('clientListDetails', JSON.stringify(data));
    this.router.navigate(['/client-partner-details'])
  }

}
